import LazyLoad from 'lazyload';

export default {
  init() {
    var loadingClass = 'loading';
    var loadedClass = 'loaded';

    function getSliderPosts (currentList) {
      currentList.addClass(loadingClass);

      $.post({
        url: window.sage.ajax_url,
        data: {
          action: 'get_slider_posts',
          json: currentList.data('json'),
          offset: $('.slider__item', currentList).length,
        },
        success: function (response) {
          if (response === 'all-posts-loaded') {
            currentList
              .addClass(loadedClass)
              .removeClass(loadingClass);
          } else {
            currentList
              .append(response)
              .removeClass(loadingClass);
            
            new LazyLoad($('img', currentList));

            setTimeout(function () {
              $('.slider__item--loading').removeClass('slider__item--loading');
            }, 1000);
          }
        },
      })
    }

    if ($('.slider').length) {
      
      $('.slider').each(function () {
        var slider = $(this);
        var sliderList = $('.slider__items', slider);
        var sliderTabs = $('.slider__tabs', slider);
        var sliderControls = $('.slider__controls', slider);
        var sliderTabActiveClass = 'slider__tab--active';

        sliderTabs.on('click', 'a', function (e) {
          e.preventDefault();

          var sliderTab = $(this).closest('li');
          
          $('.' + sliderTabActiveClass, slider).removeClass(sliderTabActiveClass);
          $('.slider__items[aria-hidden="false"]', slider).attr('aria-hidden', 'true');

          $('.slider__items[data-slider="'+ sliderTab.data('tab') +'"]', slider).attr('aria-hidden', 'false');
          sliderTab.addClass(sliderTabActiveClass);
        });

        sliderControls.on('click', 'button', function () {
          var visibleSlider = $('.slider__items[aria-hidden="false"]', slider);
          if ($(this).hasClass('slider__control--right')) {
            visibleSlider.animate({scrollLeft: visibleSlider.scrollLeft() + ($('.spotlight', visibleSlider).outerWidth() * 3) + 9}, 500);
          } else {
           visibleSlider.animate({scrollLeft: visibleSlider.scrollLeft() -$('.spotlight', visibleSlider).outerWidth() * 3 - 9}, 500);
          }
        });

        sliderList.each(function () {
          var currentList = $(this);

          $('.slider__item', currentList).length < 5 && currentList.addClass('loaded');

          currentList.on('scroll', function () {
            var lastItem = $('.slider__item', currentList).last();

            if ((lastItem.offset().left <= currentList.outerWidth() + lastItem.outerWidth()) && !currentList.is('.loading, .loaded')) {
              getSliderPosts(currentList);
            }
          });
        });
      });
    }
  },
};
